import { useIntl } from 'react-intl'
import { NavLink, useNavigate } from 'react-router-dom'
import { Controller, useFormContext } from 'react-hook-form'

import { Input } from '../../../../components/FormElements/Input'
import { PasswordInput } from '../../../../components/FormElements/PasswordInput'
import { Button } from '../../../../components/Button'
import { AuthLayout } from '../../../../components/AuthLayout'
import { CustomPhoneInput } from '../../../../components/CustomPhoneInput'

export const PersonalDataStep = () => {
  const navigate = useNavigate()

  const { formatMessage } = useIntl()
  const { control, formState, handleSubmit } = useFormContext()

  const onGoToNextStep = () => {
    navigate('/expert/register/terms')
  }

  return (
    <div className="w-full">
      <AuthLayout title={formatMessage({ id: 'REGISTRATION' })} withNavbar>
        <form
          onSubmit={handleSubmit(onGoToNextStep)}
          className="flex flex-col h-full md:h-auto"
        >
          <div className="mb-16 md:mb-8">
            <div className="mb-4">
              <Controller
                name="name"
                control={control}
                render={({
                  field: { value = '', onChange },
                  fieldState: { invalid, error, isDirty },
                }) => (
                  <Input
                    id="name"
                    label={formatMessage({ id: 'FULL_NAME' }) + '*'}
                    placeholder={formatMessage({ id: 'NAME_AND_SURNAME' })}
                    value={value}
                    onChange={onChange}
                    isValid={!invalid && isDirty}
                    errorMessage={
                      error?.message && formatMessage({ id: error.message })
                    }
                  />
                )}
              />
            </div>

            <div className="mb-4">
              <Controller
                name="email"
                control={control}
                render={({
                  field: { value = '', onChange },
                  fieldState: { invalid, error, isDirty },
                }) => (
                  <Input
                    id="email"
                    label="E-mail*"
                    placeholder="example@email.com"
                    value={value}
                    onChange={onChange}
                    isValid={!invalid && isDirty}
                    errorMessage={
                      error?.message && formatMessage({ id: error.message })
                    }
                  />
                )}
              />
            </div>

            <div className="mb-4">
              <Controller
                name="phone"
                control={control}
                render={({ field: { value = '', onChange, onBlur, name }, fieldState: { invalid, error, isDirty } }) => (
                  <CustomPhoneInput
                    label={formatMessage({ id: 'TELEPHONE' }) + '*'}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    name={name}
                    isValid={!invalid && isDirty}
                    isSubmitted={formState.isSubmitted}
                    errorMessage={error?.message && formatMessage({ id: error.message })}
                    placeholder={formatMessage({ id: 'ENTER_PHONE_NUMBER' })}
                  />
                )}
              />


            </div>

            <div>
              <Controller
                name="password"
                control={control}
                render={({
                  field: { value = '', onChange },
                  fieldState: { invalid, error, isDirty },
                }) => (
                  <PasswordInput
                    id="password"
                    label={formatMessage({ id: 'PASSWORD' }) + '*'}
                    placeholder="******"
                    value={value}
                    onChange={onChange}
                    isValid={!invalid && !isDirty}
                    errorMessage={
                      error?.message && formatMessage({ id: error.message })
                    }
                  />
                )}
              />
            </div>
          </div>

          <footer className="contents">
            <div className="flex items-end h-full mb-10 md:h-fit md:block md:items-start">
              <Button
                type="submit"
                isLoading={formState.isSubmitting}
                disabled={!formState.isValid}
                borderRadius="no-rounded"
                fullWidth
              >
                {formatMessage({ id: 'NEXT' })}
              </Button>
            </div>

            <p className="flex justify-center gap-3 text-sm lg:text-base">
              <span>{formatMessage({ id: 'ALREADY_HAVE_AN_ACCOUNT' })}</span>{' '}
              <NavLink
                to="/expert/login"
                className="font-medium underline text-primary-light"
              >
                {formatMessage({ id: 'LOGIN' })}
              </NavLink>
            </p>
          </footer>
        </form>
      </AuthLayout>
    </div>
  )
}
